"use client";
import React, { useState } from "react";
import Banner from "@/components/Banner";
import UserFormModal from "@/components/UserFormModal";
import { ChevronRight } from "lucide-react";
import Image from "next/image";

const DOWNLOAD_URL = "https://cdn.msu.edu.in/pdf/Main_Admission_Academic_session_2026-2027.pdf";
const PG_DOWNLOAD_URL = "https://cdn.msu.edu.in/msu-reavamp/pdf/MSU_Campus_PG_Prospectus_2026.pdf";
const BROCHURE_URL = "https://cdn.msu.edu.in/msu-reavamp/pdf/MSU_Prospectus_2026.pdf";

const REDIRECT_URL = "https://application.msu.edu.in/campus-programme-registration";

const Prospectus = () => {
  const [open, setOpen] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");
  const [downloadFileName, setDownloadFileName] = useState("");


    const handleFormSuccess = async () => {
        if (!shouldDownload) return;

        try {
            const response = await fetch(downloadLink);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = downloadFileName || "MSU-Brochure.pdf";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed", error);
            // window.location.replace(REDIRECT_URL);
            window.open(downloadLink, "_blank");
        } finally {
            setShouldDownload(false);
            setOpen(false);
        }
    };

  return (
    <>
      {/* Lead Capture Form */}
      <UserFormModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onSuccess={handleFormSuccess}
        shouldDownload={shouldDownload}
      />

      <Banner
        BannerImage="https://cdn.msu.edu.in/banners/ADP_7676+(1).webp"
        banner_bredcrumb_name=""
        banner_name="Prospectus-2026"
        banner_tag_line="Shaping Futures through Skill-Based Education"
      />

      <section className="w-full flex justify-center py-10 md:py-16">
        <div className="w-full max-w-6xl px-4">

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {/* CARD 1 */}
            <div className="flex flex-col items-center w-full">
              <div className="w-full overflow-hidden">
                <Image
                  src="https://cdn.msu.edu.in/website-images/msu-prospectus-2026.png"
                  alt="Prospectus 2026"
                  width={1000}
                  height={1000}
                  className="w-full  h-[380px] sm:h-[460px] md:h-[500px] object-contain bg-white"
                />
              </div>

              <button
                onClick={() => {
                  setDownloadLink(BROCHURE_URL);
                  setDownloadFileName("MSU-PROSPECTUS-2026.pdf");
                  setShouldDownload(true);
                  setOpen(true);
                }}
                className="cursor-pointer mt-6 text-[#E09512] flex items-center gap-2"
              >
                <span className="font-semibold text-lg md:text-xl tracking-wide">
                  DOWNLOAD
                </span>
                <span className="bg-[#00304b] rounded-full p-3 shadow hover:bg-black transition">
                  <ChevronRight className="w-5 h-5 text-white" />
                </span>
              </button>
            </div>
            {/* CARD 2 */}
            <div className="flex flex-col items-center w-full">
              <div className="w-full overflow-hidden">
                <Image
                  src="https://cdn.msu.edu.in/website-images/prospectus-2026.webp"
                  alt="Prospectus 2026"
                  width={1000}
                  height={1000}
                  className="w-full  h-[380px] sm:h-[460px] md:h-[500px] object-contain bg-white"
                />
              </div>

              <button
                onClick={() => {
                  setDownloadLink(DOWNLOAD_URL);
                  setDownloadFileName("MSU-ADMISSION-BROCHURE-2026.pdf");
                  setShouldDownload(true);
                  setOpen(true);
                }}
                className="cursor-pointer mt-6 text-[#E09512] flex items-center gap-2"
              >
                <span className="font-semibold text-lg md:text-xl tracking-wide">
                  DOWNLOAD
                </span>
                <span className="bg-[#00304b] rounded-full p-3 shadow hover:bg-black transition">
                  <ChevronRight className="w-5 h-5 text-white" />
                </span>
              </button>
            </div>

            {/* CARD 3 */}
            <div className="flex flex-col items-center w-full">
              <div className="w-full overflow-hidden">
                <Image
                  src="https://cdn.msu.edu.in/website-images/pg-prospectus.png"
                  alt="PG prospectus"
                  width={1000}
                  height={1000}
                  className="w-full h-[380px] sm:h-[460px] md:h-[500px] object-contain bg-white"
                />
              </div>

              <button
                onClick={() => {
                  setDownloadLink(PG_DOWNLOAD_URL);
                  setDownloadFileName("MSU-Campus-2026-PG-Prospectus.pdf");
                  setShouldDownload(true);
                  setOpen(true);
                }}
                className="cursor-pointer mt-6 text-[#E09512] flex items-center gap-2"
              >
                <span className="font-semibold text-lg md:text-xl tracking-wide">
                  DOWNLOAD
                </span>
                <span className="bg-[#00304b] rounded-full p-3 shadow hover:bg-black transition">
                  <ChevronRight className="w-5 h-5 text-white" />
                </span>
              </button>
            </div>

          </div>
        </div>
      </section>

    </>
  );
};

export default Prospectus;
